<template lang="pug">
div
  slot(name="title")
  v-radio-group.mt-0(v-model="repeatEnd" :rules="rules.not_empty" hide-details)
    v-radio(value="until" color="neutral700")
      template(v-slot:label)
        div.d-flex.align-center.font-normal
          div.text-sm.neutral700--text On date
          div.ml-3(style="width: 160px;")
            set-appointment-date(v-model="repeatUntil" placeholder="Select date" height="40" hide-details="true" :required="repeatEnd === 'until'" :min-date="getMinDate()")
    v-radio.mt-1(value="count" color="neutral700")
      template(v-slot:label)
        div.d-flex.align-center.font-normal
          div.text-sm.neutral700--text After
          div.ml-3(style="width: 50px;")
            v-text-field.text-sm.round-xl.input-number(v-model="repeatCount" outlined dense height="40" type="number" :rules="repeatEnd === 'count' ? rules.has_quantity : []" hide-details)
          div.text-sm.neutral700--text.ml-3 time(s)
    div.text-xs.danger500--text(v-if="repeatCount > 50") The maximum allowed repeat time is 50.
</template>

<script>
import SetAppointmentDate from '@/components/clinic/appointment/advance/SetAppointmentDate.vue'

export default {
  components: { SetAppointmentDate },
  props: {
    endType: {
      type: String,
      default: null,
    },
    until: {
      type: String,
      default: null,
    },
    count: {
      default: null
    },
  },
  data () {
    return {
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required', v => v <= 50 || 'number must less or equal 50'],
      },
    }
  },
  computed: {
    repeatUntil: {
      get () {
        return this.until
      },
      set (val) {
        this.$emit('update:until', val)
        this.$emit('change')
      }
    },
    repeatCount: {
      get () {
        return this.count
      },
      set (val) {
        this.$emit('update:count', val)
        this.$emit('change')
      }
    },
    repeatEnd: {
      get () {
        return this.endType
      },
      set (val) {
        this.$emit('update:endType', val)
        this.$emit('change')
      }
    }
  },
  methods: {
    getMinDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .input-number {
    text-align-last: center;
  }
}
</style>